import React, { useEffect, useState } from "react";

import Header from "./Components/Header";
import Footer from "./Components/Footer";
import About from "./Components/About";
import Experience from "./Components/Experience";
import Resume from "./Components/Resume";
import Contact from "./Components/Contact";
import Testimonials from "./Components/Testimonials";
import ProjectCards from "./Components/ProjectCards";
import PersonalProjects from "./Components/PersonalProjects";
import Certificate from "./Components/certification";
import Certificate1 from "./Components/certification1";
import CustomCursor from "./Components/CustomCursor";
import ScrollProgress from "./Components/ScrollProgress";
import TechMarquee from "./Components/TechMarquee";
import ParticlesBg from "./Components/ParticlesBg";
import AchievementBanner from "./Components/AchievementBanner";
import StatsBanner from "./Components/StatsBanner";
import SectionReveal from "./Components/SectionReveal";
import StatusBar from "./Components/StatusBar";
import "./App.css";

const App = () => {
  const [resumeData, setResumeData] = useState({});

  useEffect(() => {
    fetch("/resumeData.json")
      .then((res) => res.json())
      .then((data) => {
        setResumeData(data);
      });
  }, []);

  return (
    <div className="App">
      <CustomCursor />
      <ScrollProgress />
      <ParticlesBg />
      <Header data={resumeData.main} resumeSkills={resumeData.resume} />
      <SectionReveal>
        <About data={resumeData.main} />
      </SectionReveal>
      <TechMarquee />
      <SectionReveal>
        <Experience data={resumeData.resume} />
      </SectionReveal>
      <StatsBanner />
      <SectionReveal>
        <Testimonials data={resumeData.testimonials} />
      </SectionReveal>
      <SectionReveal>
        <Resume data={resumeData.resume} />
      </SectionReveal>
      <SectionReveal>
        <ProjectCards title="AI/ML & Web3 Projects" data={resumeData.aiProjects} theme="ai" />
      </SectionReveal>
      <SectionReveal>
        <ProjectCards title="Technical Projects" data={resumeData.techProjects} theme="backend" />
      </SectionReveal>
      <SectionReveal>
        <PersonalProjects data={resumeData.personalProjects} />
      </SectionReveal>
      <AchievementBanner />
      <SectionReveal>
        <Certificate data={resumeData.honours10} />
      </SectionReveal>
      <SectionReveal>
        <Certificate1 data={resumeData.honours11} />
        <Certificate1 data={resumeData.honours} />
        <Certificate1 data={resumeData.honours12} />
      </SectionReveal>
      <SectionReveal>
        <Contact data={resumeData.main} />
      </SectionReveal>
      <Footer data={resumeData.main} />
      <StatusBar />
    </div>
  );
};

export default App;
